import {get, post, postJson} from './axios'

// 短信账单统计
const RESOURCE_BASE_PATH = '/smsRecordStatistics'
// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms/smsRecordStatistics'

// 短信账单汇总查询
export const getSmsRecord = p => get(`${RESOURCE_BASE_PATH}/`, p);